import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 4px;

  background-color: ${getToken('color-neutral-white')};
  border: 1px solid ${getToken('color-neutral-darker')};
  border-radius: 4px;
`

const Items = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 100%;

  color: ${({ checked }) =>
    checked ? getToken('color-neutral-white') : getToken('color-neutral-darker')};
  font-weight: 500;
  font-size: 16px;

  background-color: ${({ checked }) =>
    checked ? getToken('color-neutral-darker') : getToken('color-neutral-white')};
  border-radius: 4px;
  cursor: pointer;

  user-select: none;

  & input[type='radio'] {
    display: none;
  }

  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`

function ModeToggle(props) {
  const { options, name, value, onChange } = props

  return (
    <Container>
      {options.map(option => (
        <Items key={`${name}-${option.value}`} checked={value === option.value}>
          {option.icon()}
          <input type="radio" name={name} onChange={onChange} value={option.value} />
          <div className={option.label}>{option.label}</div>
        </Items>
      ))}
    </Container>
  )
}

ModeToggle.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
}

ModeToggle.defaultProps = {
  name: null,
  options: [],
}

export { ModeToggle }
